<app-component-header></app-component-header>

<div class="component-block">

<section class="block-formControlWrap">
    <div class="container">
        <div class="row">
            <div class="margin-bottom-5">
                <div class="col-xs-6">
                    <div class="page-head">
                        <div class="page-title">

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="block-formControl">
                    <div class="portlet light portlet-datatable bordered">
                        <div class="option-row">
                            <div>
                                Xác nhận email từ khách hàng
                            </div>
                        </div>
                        <div class="form-input portlet light booking-input row">
                            <div *ngIf="enableCaptcha">
                                <!-- using (Html.BeginForm("VerifyEmail", "Home", FormMethod.Post, new { enctype = "multipart/form-data", id = "form-verify" }))
                                {
                                    <input type="hidden" name="SValue" value="@TempData["SValueVerifyEmail"]" />
                                    <div style="width:300px;margin:0 auto;">
                                        <label> Mã bảo vệ <span style="color:red">(*)</span></label>
                                        @Html.Captcha("Thử mã khác", "Vui lòng nhập mã bảo vệ theo hình trên.", 5)
                                        <input type="submit" value="Xác nhận" class="btn btn-sm btn-info" onclick="return confirmEmail()" />
                                    </div>
                                } -->
                                <form [formGroup]="formCaptcha">
                                    <ngx-recaptcha2
                                        [siteKey]="siteKey"
                                        (success)="handleSuccess()"
                                        formControlName="recaptcha">
                                    </ngx-recaptcha2>
                                </form>
                        </div>
                            <div *ngIf="!enableCaptcha">
                                <div class="row text-center">
                                    <img src="assets/img/email/email_checked.png" style="width:20%;" />
                                    <h3>Xác nhận email đã hoàn tất.</h3>
                                    <span>Trân trọng cảm ơn quý khách.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>

<app-component-footer></app-component-footer>